import { AppBarProps as MuiAppBarProps } from '@mui/material/AppBar/AppBar';
import { styled } from '@mui/material/styles';
import MuiAppBar from '@mui/material/AppBar';
import { Link } from 'react-router-dom';
import { FONT_DISPLAY } from 'themes/tokens';

interface AppBarProps extends MuiAppBarProps {
  open?: boolean;
  fullWidth?: boolean;
}

export const AppBar = styled(MuiAppBar, {
  shouldForwardProp: (prop) => prop !== 'open' && prop !== 'fullWidth',
})<AppBarProps>(({ theme, open, fullWidth }) => ({
  backgroundColor: theme.palette.background.paper,
  color: theme.palette.text.primary,
  borderBottom: `1px solid ${theme.palette.divider}`,
  zIndex: theme.zIndex.drawer + 1,
  transition: theme.transitions.create(['width', 'margin'], {
    easing: theme.transitions.easing.sharp,
    duration: theme.transitions.duration.leavingScreen,
  }),
  ...(open && {
    transition: theme.transitions.create(['width', 'margin'], {
      easing: theme.transitions.easing.sharp,
      duration: theme.transitions.duration.enteringScreen,
    }),
  }),
  ...(fullWidth && {
    transition: theme.transitions.create(['width', 'margin'], {
      easing: theme.transitions.easing.sharp,
      duration: theme.transitions.duration.enteringScreen,
    }),
  }),
}));

export const LogoLink = styled(Link)(({ theme }) => ({
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'center',
  gap: theme.spacing(1),
  padding: theme.spacing(0, 1),
  textDecoration: 'none',
  ...theme.mixins.toolbar,
}));

export const GtxWordmark = styled('div')(({ theme }) => ({
  paddingLeft: 16,
  fontFamily: FONT_DISPLAY,
  fontWeight: 700,
  fontSize: 24,
  lineHeight: 1,
  letterSpacing: '-0.02em',
  color: theme.palette.text.primary,
  userSelect: 'none',
  transition: 'filter 0.2s ease',
  '& .gtx-dot': {
    color: theme.palette.accent.main,
  },
  '&:hover': {
    filter: `drop-shadow(0 0 6px ${theme.palette.primary.main})`,
  },
}));
